import React, { useState } from 'react';
import { Save, Download, Upload } from 'lucide-react';
import { Button } from '../../components/ui/button';
import { Input } from '../../components/ui/input';
import { Label } from '../../components/ui/label';
import { Card, CardContent, CardHeader, CardTitle } from '../../components/ui/card';
import { Tabs, TabsContent, TabsList, TabsTrigger } from '../../components/ui/tabs';
import { Textarea } from '../../components/ui/textarea';
import { useToast } from '../../hooks/use-toast';

const AdminTranslations = () => {
  const { toast } = useToast();
  const [translations, setTranslations] = useState({
    en: {
      'hero.title': 'Transform Your',
      'hero.description': 'Premium car electronics solutions including Android screens...',
      'nav.home': 'HOME',
      'nav.shop': 'SHOP',
      'nav.contact': 'CONTACT'
    },
    ar: {
      'hero.title': 'حوّل تجربة',
      'hero.description': 'حلول إلكترونيات السيارات المتميزة...',
      'nav.home': 'الرئيسية',
      'nav.shop': 'المتجر',
      'nav.contact': 'اتصل بنا'
    }
  });

  const handleSave = () => {
    toast({ title: "Success", description: "Translations saved successfully" });
  };

  const handleExport = () => {
    const dataStr = JSON.stringify(translations, null, 2);
    const dataUri = 'data:application/json;charset=utf-8,' + encodeURIComponent(dataStr);
    const exportFileDefaultName = 'translations.json';
    
    const linkElement = document.createElement('a');
    linkElement.setAttribute('href', dataUri);
    linkElement.setAttribute('download', exportFileDefaultName);
    linkElement.click();
    
    toast({ title: "Success", description: "Translations exported successfully" });
  };

  return (
    <div>
      <div className="flex justify-between items-center mb-6">
        <div>
          <h2 className="text-3xl font-bold text-gray-900">Translations Management</h2>
          <p className="text-gray-600 mt-1">Manage English and Arabic translations</p>
        </div>
        <div className="flex gap-2">
          <Button variant="outline" onClick={handleExport}>
            <Download className="mr-2 h-4 w-4" />
            Export
          </Button>
          <Button className="bg-red-600 hover:bg-red-700" onClick={handleSave}>
            <Save className="mr-2 h-4 w-4" />
            Save Changes
          </Button>
        </div>
      </div>

      <Card>
        <CardHeader>
          <CardTitle>Translation Keys</CardTitle>
        </CardHeader>
        <CardContent>
          <Tabs defaultValue="navigation">
            <TabsList className="grid w-full grid-cols-5">
              <TabsTrigger value="navigation">Navigation</TabsTrigger>
              <TabsTrigger value="hero">Hero</TabsTrigger>
              <TabsTrigger value="products">Products</TabsTrigger>
              <TabsTrigger value="services">Services</TabsTrigger>
              <TabsTrigger value="contact">Contact</TabsTrigger>
            </TabsList>

            <TabsContent value="navigation" className="space-y-4 mt-4">
              <div className="grid grid-cols-2 gap-4">
                <div>
                  <Label>nav.home (EN)</Label>
                  <Input value="HOME" />
                </div>
                <div>
                  <Label>nav.home (AR)</Label>
                  <Input value="الرئيسية" dir="rtl" />
                </div>
                <div>
                  <Label>nav.shop (EN)</Label>
                  <Input value="SHOP" />
                </div>
                <div>
                  <Label>nav.shop (AR)</Label>
                  <Input value="المتجر" dir="rtl" />
                </div>
                <div>
                  <Label>nav.contact (EN)</Label>
                  <Input value="CONTACT" />
                </div>
                <div>
                  <Label>nav.contact (AR)</Label>
                  <Input value="اتصل بنا" dir="rtl" />
                </div>
              </div>
            </TabsContent>

            <TabsContent value="hero" className="space-y-4 mt-4">
              <div className="grid grid-cols-2 gap-4">
                <div>
                  <Label>hero.title (EN)</Label>
                  <Input value="Transform Your" />
                </div>
                <div>
                  <Label>hero.title (AR)</Label>
                  <Input value="حوّل تجربة" dir="rtl" />
                </div>
                <div>
                  <Label>hero.description (EN)</Label>
                  <Textarea rows={3} value="Premium car electronics solutions including Android screens, sound systems, LED lights, and professional installation services." />
                </div>
                <div>
                  <Label>hero.description (AR)</Label>
                  <Textarea rows={3} value="حلول إلكترونيات السيارات المتميزة بما في ذلك شاشات أندرويد وأنظمة الصوت وأضواء LED وخدمات التركيب الاحترافية." dir="rtl" />
                </div>
              </div>
            </TabsContent>

            <TabsContent value="products" className="space-y-4 mt-4">
              <p className="text-gray-600">Product translation management - Coming soon</p>
            </TabsContent>

            <TabsContent value="services" className="space-y-4 mt-4">
              <p className="text-gray-600">Services translation management - Coming soon</p>
            </TabsContent>

            <TabsContent value="contact" className="space-y-4 mt-4">
              <p className="text-gray-600">Contact translation management - Coming soon</p>
            </TabsContent>
          </Tabs>
        </CardContent>
      </Card>

      <Card className="mt-6">
        <CardHeader>
          <CardTitle>Bulk Import/Export</CardTitle>
        </CardHeader>
        <CardContent>
          <div className="space-y-4">
            <div>
              <Label>Import Translations (JSON)</Label>
              <div className="flex gap-2 mt-2">
                <Input type="file" accept=".json" />
                <Button variant="outline">
                  <Upload className="mr-2 h-4 w-4" />
                  Import
                </Button>
              </div>
            </div>
            <p className="text-sm text-gray-600">
              Upload a JSON file with translation keys. Format: {`{ "en": {...}, "ar": {...} }`}
            </p>
          </div>
        </CardContent>
      </Card>
    </div>
  );
};

export default AdminTranslations;